import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import * as echarts from 'echarts'
import "../src/assets/css/common.css"
import "./assets/iconfont/iconfont.css"
// import 'default-passive-events' //控制台警告
import iconFront from "./assets/iconfont/iconfont.js"
import moment from "moment"
import { createFromIconfontCN } from '@ant-design/icons-vue'
const myicon = createFromIconfontCN({
  scriptUrl: iconFront
})
const app = createApp(App)
app.config.globalProperties.$echarts = echarts
app.config.globalProperties.$moment = moment
app.component('my-icon',myicon)
app.use(router)
app.use(Antd)
app.mount('#app')